module.exports = "/_next/static/images/employee-activation-19c2aa9b277ee7bde3684e911933556f.svg";